import { Sparkles } from "lucide-react";

/**
 * Small green "Premium" chip used next to a supplier's name.
 * Shows a native tooltip on hover explaining the tier — nudge for free suppliers to upgrade.
 */
export default function PremiumBadge({ size = "sm", testId }) {
  const s = size === "md"
    ? "text-xs px-2.5 py-1 gap-1.5"
    : "text-[10px] px-2 py-0.5 gap-1";
  const icon = size === "md" ? "w-3 h-3" : "w-2.5 h-2.5";
  return (
    <span
      className={`inline-flex items-center font-mono font-bold uppercase tracking-wider rounded-full bg-gradient-to-r from-emerald-500 to-emerald-600 text-white shadow-sm cursor-help ${s}`}
      title="Fornitore con piano attivo (Basic €29,99 · Pro €99,99 · Enterprise €299/mese): commissione ridotta o azzerata, offerte prioritarie, boost visibilità."
      data-testid={testId || "premium-badge"}
    >
      <Sparkles className={icon} /> Premium
    </span>
  );
}
